import { usePropertyContext } from '@/context/propertyContext';
import {
	GroupPricingNumberField,
	GroupPricingSlider,
} from '@/features/group-pricing/components/inputs';
import { useFormContext, useWatch } from 'react-hook-form';

export function AdvancedForm() {
	const form = useFormContext();
	const { currencySymbol } = usePropertyContext();

	const [requestedRate, roomsRequested] = useWatch({
		control: form.control,
		name: ['rate_requested', 'rooms_requested'],
	});

	return (
		<div className='tw-grid tw-grid-cols-1 tw-gap-6 md:tw-grid-cols-2 lg:tw-grid-cols-3'>
			<GroupPricingSlider
				name='direct_var_opex'
				description='Variable Opex per room night.'
				symbol={{ prefix: currencySymbol }}
				max={requestedRate - 1}
			/>

			<GroupPricingSlider
				name='wash_factor'
				description='Wash factor.'
				symbol={{ suffix: '%' }}
			/>

			<GroupPricingSlider
				name='rebate'
				description='Rebate per room.'
				symbol={{ prefix: currencySymbol }}
				max={requestedRate - 1}
			/>

			<GroupPricingNumberField
				name='f_and_b_profit'
				description='F&B Profit per group.'
				symbol={{ prefix: currencySymbol }}
				min={0}
				max={1000}
			/>

			<GroupPricingSlider
				name='meeting_space_benefit'
				description='Meeting space benefit.'
				symbol={{ prefix: currencySymbol }}
				max={requestedRate * 10}
			/>

			<GroupPricingSlider
				name='comp_rooms'
				description='Comp rooms per night.'
				max={roomsRequested}
			/>

			<GroupPricingSlider
				name='occ_fcst_override'
				description='Occupancy forecast override.'
				symbol={{ suffix: '%' }}
				min={-100}
			/>

			<GroupPricingSlider
				name='adr_fcst_override'
				description='ADR forecast override.'
				min={-100}
				symbol={{ suffix: '%' }}
			/>

			<GroupPricingSlider
				name='planners_adv_points'
				description='Planners Advantage points/$.'
			/>

			<GroupPricingSlider
				name='avg_stay_length'
				description='Average length of stay.'
				step={0.25}
				max={30}
			/>
		</div>
	);
}
